import React, { useRef } from 'react';
import './InvoiceHeader.css';

const InvoiceHeader = ({ logo, onLogoUpload, invoiceNumber, onInvoiceNumberChange }) => {
  const fileInputRef = useRef(null);

  const handleLogoUploadChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        onLogoUpload(e.target.result); // Call the handler from InvoiceForm
      };
      reader.readAsDataURL(file);
    }
  };

  const handleLogoClick = () => {
    fileInputRef.current.click();
  };

  const handleRemoveLogo = () => {
    onLogoUpload(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  return (
    <div className="invoice-header">
      <div className="logo" onClick={handleLogoClick}> {/* Added onClick here */}
        <input
          type="file"
          id="logo-upload"
          accept="image/*"
          onChange={handleLogoUploadChange}
          style={{ display: 'none' }}
          ref={fileInputRef}
        />
        <div id="logo-placeholder">
          {logo ? <img src={logo} alt="Logo" style={{maxWidth:"100px", maxHeight:"100px"}}/> : "Add Logo"}
        </div>
        {logo && (
          <button className="remove-logo" onClick={handleRemoveLogo}>
            &times;
          </button>
        )}
      </div>
      <div className="invoice-info">
        <label htmlFor="invoice-number">TAX INVOICE</label>
        
        <input type="text" id="invoice-number" name="invoiceNumber" value={invoiceNumber} onChange={onInvoiceNumberChange} required />
      </div>
    </div>
  );
};

export default InvoiceHeader;